import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import styles from "./Popular-Instructours.module.css";

function PopularInstructor() {
  const [t, i18n] = useTranslation("global");
  const [instructors, setInstructors] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchPopularInstructors = async () => {
      setLoading(true);
      try {
        const response = await fetch(`${process.env.REACT_APP_API_URL}/most-instructors`, {
          headers: {
            "Accept-Language": i18n.language,
          },
        });

        const data = await response.json();
        if (data.status === "success") {
          setInstructors(data.data);
        } else {
          console.error("Error fetching instructors:", data.message);
        }
      } catch (error) {
        console.error("Error fetching instructors:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchPopularInstructors();
  }, [i18n.language]);

  if (loading) {
    return (
      <section className={styles.popularInstructorsSection}>
        <div className="container">
          <div className={styles.sectionHeader}>
            <h1 className={styles.sectionTitle}>
              {t("instructors.titleOne")} <br /> {t("instructors.titleTwo")}
            </h1>
            <p className={styles.sectionDescription}>
              {t("instructors.description")}
            </p>
          </div>
          
          <div className={styles.instructorsContainer}>
            <div className={`row ${styles.instructorsRow}`}>
              {[1, 2, 3].map((item) => (
                <div key={item} className="col-lg-4 col-md-6 mb-3 d-flex justify-content-center">
                  <div className={styles.skeletonCard}>
                    <div className={styles.skeletonImage}></div>
                    <div className={styles.instructorCardBody}>
                      <div className={styles.skeletonTitle}></div>
                      <div className={styles.skeletonText}></div>
                      <div className={styles.skeletonText} style={{ width: '70%' }}></div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>
    );
  }

  return (
    <section className={styles.popularInstructorsSection}>
      <div className="container">
        <div className={styles.sectionHeader}>
          <h1 className={styles.sectionTitle}>
            {t("instructors.titleOne")} <br /> {t("instructors.titleTwo")}
          </h1>
          <p className={styles.sectionDescription}>
            {t("instructors.description")}
          </p>
        </div>

        <div className={styles.instructorsContainer}>
          <div className={`row ${styles.instructorsRow}`}>
            {instructors.length > 0 ? (
              instructors.map((instructor) => (
                <div
                  key={instructor.id}
                  className="col-lg-4 col-md-6 mb-3 d-flex justify-content-center"
                >
                  <div className={styles.instructorCard}>
                    <Link
                      to={`/instructortDetails/${instructor.id}`}
                      className="text-decoration-none"
                    >
                      <div className={styles.instructorImageContainer}>
                        <img
                          src={instructor.image}
                          className={styles.instructorImage}
                          alt={instructor.name}
                        />
                      </div>
                      <div className={styles.instructorCardBody}> 
                        <h5 className={styles.instructorName}>
                          {instructor.name}
                        </h5>
                        <p className={styles.instructorPosition}>
                          {instructor.position}
                        </p>
                      </div>
                    </Link>

                    <div className={styles.socialLinksContainer}>
                      <div className={styles.socialLinks}>
                        {instructor?.facebook && (
                          <a href={instructor.facebook} className={`${styles.socialLink} ${styles.facebook}`} aria-label="Facebook">
                            <i className="fab fa-facebook-f"></i>
                          </a>
                        )}

                        {instructor?.twitter && (
                          <a href={instructor.twitter} className={`${styles.socialLink} ${styles.twitter}`} aria-label="X (Twitter)">
                            <i className="fab fa-x-twitter"></i>
                          </a>
                        )}

                        {instructor?.youtube && (
                          <a href={instructor.youtube} className={`${styles.socialLink} ${styles.youtube}`} aria-label="YouTube">
                            <i className="fab fa-youtube"></i>
                          </a>
                        )}

                        {instructor?.tiktok && (
                          <a href={instructor.tiktok} className={`${styles.socialLink} ${styles.tiktok}`} aria-label="TikTok">
                            <i className="fab fa-tiktok"></i>
                          </a>
                        )}

                        {instructor?.whatsapp && (
                          <a href={instructor.whatsapp} className={`${styles.socialLink} ${styles.whatsapp}`} aria-label="WhatsApp">
                            <i className="fab fa-whatsapp"></i>
                          </a>
                        )}

                        {instructor?.telegram && (
                          <a href={instructor.telegram} className={`${styles.socialLink} ${styles.telegram}`} aria-label="Telegram">
                            <i className="fab fa-telegram-plane"></i>
                          </a>
                        )}

                        {instructor?.snapchat && (
                          <a href={instructor.snapchat} className={`${styles.socialLink} ${styles.snapchat}`} aria-label="Snapchat">
                            <i className="fab fa-snapchat-ghost"></i>
                          </a>
                        )}

                        {instructor?.instagram && (
                          <a href={instructor.instagram} className={`${styles.socialLink} ${styles.instagram}`} aria-label="Instagram">
                            <i className="fab fa-instagram"></i>
                          </a>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              ))
            ) : (
              <div className="col-12">
                <p className={styles.noInstructorsMessage}>{t("instructors.noPopularInstructors")}</p>
              </div>
            )}
          </div>
        </div>
      </div>
    </section>
  );
}

export default PopularInstructor;
